const columnMappings = {
  last_visit_at: 'Last Visit At',
  last_visit_path: 'Last Path',
  'company->metrics->employees_range': 'Size',
  'company->metrics->employees': 'Size',
  'company->geo->state_code': 'State',
  'company->name': 'Company',
  'person->employment->title': 'Title',
  'person->email': 'Email',
  'person->name->full_name': 'Name',
};

export default columnMappings;
